import React, { useState, lazy } from 'react';
import PropTypes from 'prop-types';
import RenderComponent from './RenderComponent';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Form = lazy(() => import(`globalcomponents/UI/Form/${layout}`));

const Filters = ({
    hasApiStatus,
    callback,
    history,
    severityList,
    eventsList,
    filterList,
    handleReset,
    values,
    setInitialValues,
}) => {
    const [validationError, setValidationError] = useState('');
    const resetValidationError = () => setValidationError('');
    
    const processFields = (fields) => {
        const finalData = JSON.parse(JSON.stringify(fields));
        Object.keys(finalData).forEach((key) => {
            finalData[key] = finalData[key]?.value || null;
        });
        return finalData;
    };

    return (
        <>
            <Form
                type="server"
                direction="row"
                initialValues={{ ...values }}
                className="CSAForms"
                RenderComponent={RenderComponent}
                handleOnSubmit={(fields) => {
                    resetValidationError();
                    const finalData = processFields(fields);
                    filterList(finalData);
                }}
                handleOnCancel={() => {
                    handleReset();
                    setInitialValues({
                        severityId: null,
                    });
                    resetValidationError();
                }}
                customProps={{
                    history,
                    callback,
                    hasApiStatus,
                    validationError,
                    severityList,
                    eventsList,
                    setInitialValues,
                }}
            />
        </>
    );
};

Filters.propTypes = {
    hasApiStatus: PropTypes.bool.isRequired,
    callback: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    severityList: PropTypes.array.isRequired,
    eventsList: PropTypes.array.isRequired,
    filterList: PropTypes.func.isRequired,
    handleReset: PropTypes.func.isRequired,
    values: PropTypes.object.isRequired,
    setInitialValues: PropTypes.func.isRequired,
};

Filters.defaultProps = {
    hasApiStatus: false,
    severityList: [],
    eventsList: [],
    values: {},
};

export default Filters;